import { render, staticRenderFns } from "./AdminPricingPlanForm.vue?vue&type=template&id=f5128de2"
import script from "./AdminPricingPlanForm.vue?vue&type=script&lang=js"
export * from "./AdminPricingPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5128de2')) {
      api.createRecord('f5128de2', component.options)
    } else {
      api.reload('f5128de2', component.options)
    }
    module.hot.accept("./AdminPricingPlanForm.vue?vue&type=template&id=f5128de2", function () {
      api.rerender('f5128de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminPricingPlanForm.vue"
export default component.exports